<template>
    <div>
        <MainLayout>
            <template #header>
                <GlobalSearchHeader />
            </template>

            <template #left>
                <GlobalSearchTabs />
            </template>

            <template #right>
                <GlobalSearchFilter />
            </template>
            <template #footer>
                <p>Footer content goes here</p>
            </template>
            <template #notification>
                <GlobalSearchSnackbar />
            </template>
        </MainLayout>
    </div>
</template>
<script setup lang="ts">
import GlobalSearchTabs from '../components/GlobalSearchTabs.vue';
import GlobalSearchFilter from '../components/GlobalSearchFilter.vue';
import GlobalSearchHeader from '../components/GlobalSearchHeader.vue';
import GlobalSearchSnackbar from '../components/GlobalSearchSnackbar.vue';
import MainLayout from '../layouts/MainLayout.vue';
import { onMounted } from 'vue';
import { useUserStore } from 'src/stores/userStore';
const userStore = useUserStore();
onMounted(async () => {
    await userStore.getUserInformation();
    await userStore.getWsInformation();
});
</script>
